import React from 'react'
import Skeleton from '@mui/material/Skeleton'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 20px 0;
`
const StyledSkeleton = styled(Skeleton)`
  border-radius: 30px;
`

const InputSkeleton = (props: any) => {
  return (
    <Wrapper>
      <StyledSkeleton variant="rectangular" height={48} {...props} />
    </Wrapper>
  )
}

export default InputSkeleton
